import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { fileParms } from './file-processing.model';
import { DescriptionModel } from '../base.model';

@Injectable({
  providedIn: 'root',
})
export class FileProcessingService {
  constructor(private http: HttpClient, private toastrService: ToastrService) {}

  downloadFile(documentId: number): Observable<any> {
    let HTTPOptions: Object = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;',
      }),
      observe: 'response',
      responseType: 'arraybuffer',
    };
    return this.http
      .get<any>(
        `${AppConfig.settings.settings.apiEndpoint}api/FileProcessing/Download?documentId=${documentId}`,
        HTTPOptions
      )
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  getAllFiles(params: fileParms): Observable<any[]> {
    return this.http
      .post<any[]>(
        `${AppConfig.settings.settings.apiEndpoint}api/FileProcessing/GetAllFiles`,
        params
      )
      .pipe(
        map(data => {
          if (data != null && data != undefined) {
            data.map(f => {
              f.documentCreatedDateUtc =
                f.documentCreatedDateUtc == null || f.documentCreatedDateUtc == undefined
                  ? null
                  : new Date(f.documentCreatedDateUtc);
              f.documentLastModifiedDate =
                f.documentLastModifiedDate == null || f.documentLastModifiedDate == undefined
                  ? null
                  : new Date(f.documentLastModifiedDate);
            });
          }
          return data;
        })
      );
  }

  getFileTypeDescriptions(): Observable<DescriptionModel[]> {
    return this.http
      .get<DescriptionModel[]>(AppConfig.settings.settings.apiEndpoint + 'api/FileProcessing/GetFileTypeDescriptions')
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  uploadFile(params: fileParms): Observable<any> {
    return this.http
      .post<number>(
        `${AppConfig.settings.settings.apiEndpoint}api/FileProcessing/Upload?clientInfoId=${params.clientInfoId}&type=${params.type}`,
        params.files[0],
        { reportProgress: true, observe: 'events' }
      )
      .pipe(
        map(
          event => {
            if (event.type === HttpEventType.UploadProgress) {
            } else if (event.type === HttpEventType.Response) {
              this.toastrService.success('File uploaded successfully.', '');
              return true;
            }
          },
          error => {
            return of([]);
          }
        )
      );
  }

  validateFile(params: fileParms): Observable<boolean> {
    return this.http
      .get<boolean>(
        `${AppConfig.settings.settings.apiEndpoint}api/FileProcessing/Validate?clientInfoId=${params.clientInfoId}&fileTypeId=${params.fileTypeId}&type=${params.type}`
      )
      .pipe(
        map(data => {
          return data;
        })
      );
  }
}
